import * as AmazonCognitoIdentity from "amazon-cognito-identity-js";

const getUserCognito = (username) => {
  return new Promise((resolve, reject) => {
    try {
      const poolData = {
        UserPoolId: process.env.REACT_APP_USER_POOL_ID,
        ClientId: process.env.REACT_APP_CLIENT_ID,
      };

      const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
      const userData = {
        Username: username,
        Pool: userPool,
      };

      const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

      if (cognitoUser !== null) {
        cognitoUser.getSession((err) => {
          if (err) {
            reject(err.message || JSON.stringify(err));
          }
          cognitoUser.getUserAttributes((err, result) => {
            if (err) {
              reject(err.message || JSON.stringify(err));
            }
            resolve(result);
          });
        });
      } else {
        reject("No Cognito User");
      }
    } catch (err) {
      reject(err || JSON.stringify(err));
    }
  });
};

export default getUserCognito;
